<p-selectButton
  [(ngModel)]="chartRange"
  [options]="rangeOptions"
  size="small"
  (onChange)="updateChartRange()" />

@if (isCalendarOpen) {
  <app-input-calendar
    [(ngModel)]="selectedRange"
    (ngModelChange)="updateChartRange()"
    [formData]="chartDateRangeConfig" />
}